import React from "react";
import "./Privacy_Policy_content.css";

function Privacy_Policy_content() {
  return (
    <>
      <section className="Terms_Conditions_content_holder">
        <div className="container">
          <div className="Terms_Conditions_content">
            <div className="text_holder">
              <h4>Privacy Policy</h4>
              <p>Your privacy is very important to us. This Privacy Policy outlines how [Profcyma Finance]
                (“we”, “us”, or “our”) collects, uses, shares, and protects your information when you visit our
                website or use our services in India.</p>
            </div>

            <div className="text_holder">
              <h4>1. Information We Collect</h4>
              <ul>
                <li><strong>Personal Information:</strong>We collect your name, address, date of birth, PAN, Aadhaar
                  number (as per regulations), contact details, employment, and income information
                  when you apply for a loan.</li>
                <li><strong>Usage Information:</strong> Details about your visit such as IP address, browser type,
                  device details, and how you interact with our website.</li>
                <li><strong>Cookies:</strong>We use cookies and similar technologies for website functionality, analytics, and improving user experience.</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>2.How We Use Your Information</h4>
              <ul>
                <li>To process, assess, and verify your loan application.</li>
                <li>To communicate loan status and updates.</li>
                <li>To comply with requirements of the Reserve Bank of India (RBI), regulatory, and legal entities.</li>
                <li>For marketing, advertising, analytics (where you consent).</li>
                <li>To improve site interface and our offerings.</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>3.Information Sharing</h4>
              <ul>
                <li>We may share your information with:</li>
                <li>Credit bureaus, KYC agencies, and payment partners for verification and
                  processing.</li>
                <li>Our affiliates and service providers, as permitted under the law.</li>
                <li>Regulatory authorities, enforcement agencies, or as required by Indian laws.</li>
                <li>Your personal data will not be sold to unaffiliated third parties.</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>4.Data Security</h4>
              <ul>
                <li>We use appropriate security measures as per the Information Technology Act, 2000
                  (and related rules) to protect your data from unauthorised access.</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>5.Your Choices and Rights</h4>
              <ul>
                <li>You can disable cookies through browser settings and unsubscribe from our
                  marketing communications at any time.</li>
                <li>You may review or request corrections to your personal data by contacting us.</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>6. Children’s Privacy</h4>
              <ul>
                <li>Our services are not intended for persons under the age of 18.</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>7.Changes to this Policy</h4>
              <ul>
                <li>Any updates will be posted on this page. Please review regularly.</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>8.Contact Us</h4>
              <ul>
                <li>For any privacy concerns or to exercise your data rights, contact us at: [1800-267-8961 / +91 96077 55557].</li>
              </ul>
            </div>



          </div>
        </div>
      </section>
    </>
  );
}

export default Privacy_Policy_content;
